import { Sparkles } from "lucide-react";
import { GlassCard, SectionTitle } from "../components/common/ui";

export default function PublicInfo({ eyebrow, title, subtitle, phase = "Phase 2" }) {
  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-24" data-testid="public-info-page">
      <SectionTitle eyebrow={eyebrow} title={title} subtitle={subtitle} />
      <GlassCard className="mt-12 p-14 flex flex-col items-center text-center" hover={false}>
        <div className="grid place-items-center h-16 w-16 rounded-2xl bg-gradient-to-br from-amber to-fireorange">
          <Sparkles className="h-8 w-8 text-ink" />
        </div>
        <p className="mt-6 font-playfair text-2xl text-white">Coming in {phase}</p>
        <p className="mt-2 text-muted-foreground max-w-lg">
          This page is part of the CMS-driven experience and will be fully built out in {phase} of the Clacton Fireworks roadmap.
        </p>
      </GlassCard>
    </div>
  );
}
